export type SiteConfig = typeof siteConfig;

export const siteConfig = {
	name: "Doge Clicker: Dogecoin Mining Game",
	description:
		"Embark on an interstellar journey with Doge Clicker! Start by mining Dogecoins on Earth, then rocket to the Moon, and even set your sights on Mars.",
	navItems: [
		{
			label: "Price Chart",
			href: "/chart/",
		},
		{
			label: "The Origin",
			href: "/origin/",
		},
		{
			label: "Doge Song",
			href: "/music/",
		},
		{
			label: "Flip A Coin",
			href: "/coin/",
		},
		{
			label: "Crypto Hacker",
			href: "https://sombra.dogeclicker.com/",
		},
		{
			label: "Wallet Simulator",
			href: "https://wallet.dogeclicker.com/",
		},
	],
	navMenuItems: [
		{
			label: "Price Chart",
			href: "/chart/",
		},
		{
			label: "The Origin",
			href: "/origin/",
		},
		{
			label: "Doge Song",
			href: "/music/",
		},
		{
			label: "Flip A Coin",
			href: "/coin/",
		},
		{
			label: "Cat Stacker",
			href: "https://cat.dogeclicker.com/",
		},
		{
			label: "Crypto Hacker",
			href: "https://sombra.dogeclicker.com/",
		},
		{
			label: "Wallet Simulator",
			href: "https://wallet.dogeclicker.com/",
		},
	],
	links: {
		story_t: "A Letter",
		story: "/letter/",
		privacy_t: "Privacy",
		privacy: "/privacy/",
	},
};
